import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { Select } from 'gu-ui-kit'
import useSwitchedUser from 'utils/hooks/useSwitchedUser'
import PropTypes from 'prop-types'

const UserSwitcher = ({ email, id, className }) => {
  let req = null
  let source
  const CancelToken = axios.CancelToken
  const { t } = useTranslation()
  const { switchedUser, switchUser } = useSwitchedUser()

  return (
    !switchedUser && (
      <Select
        className={className}
        size={'s'}
        label={t('common::select_empty_option')}
        value={switchedUser?.id}
        emptyOptionLabel={t('common::select_empty_option')}
        clearOptionLabel={t('common::select_clear_option')}
        fullWidth
        t={t}
        onChangeOption={(selectedOption) =>
          !selectedOption.empty &&
          email !== selectedOption.label &&
          switchUser(selectedOption.label)
        }
        requestDataFunction={({ searchPhrase }) => {
          if (req) {
            source.cancel()
          }

          source = CancelToken.source()

          req = axios
            .get(`/suggest/user/suggest?q=${searchPhrase}&page=1`, {
              cancelToken: source.token,
            })
            .then(({ data }) => ({
              ...data,
              items: data.items
                .filter((item) => item.id !== id)
                .map((item) => ({
                  ...item,
                  value: item.id,
                  label: item.text,
                })),
            }))

          return req
        }}
        mode={'filter'}
        noResultsLabel={t('common::empty_results.header')}
      />
    )
  )
}

UserSwitcher.propTypes = {
  email: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.number,
}

export default UserSwitcher
